import PropTypes from "prop-types";
import React from "react";
import { scrbData } from "../ScrbTools";
import { useHookstate } from "@hookstate/core";
import { I18n } from "aws-amplify";
import classNames from "classnames";
import { Button } from "primereact/button";

InstallationCard.propTypes = {
    installation: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
    dragging: PropTypes.bool,
    onRemove: PropTypes.func,
    viewMode: PropTypes.bool,
    printMode: PropTypes.bool
}

function InstallationCard(props) {

    const data = useHookstate(scrbData).get();
    const inst = props.installation;

    const getLastReceptionStatus = (installation) => {
        if (installation.statut) {
            const value = data.recStatusList.find(statut => statut.id === installation.statut);
            let color = "tournee-status-nonConfirme";
            if (value.id > 4) color = "tournee-status-validee";
            else if (value.id === 2) color = "tournee-status-attente";
            else if (value.id === 1) color = "tournee-status-nonDemande";
            return (<div className={`tournee-status ${color}`}>{I18n.get(value.label)}</div>);
        }
        return (<div className={`tournee-status tournee-status-attente`}>{I18n.get("nonPlanifie")}</div>);
    }

    const getConformiteImage = (installation) => {
        if ([1, true].includes(installation.isConforme)) {
            return <><i className="fa-light fa-thumbs-up text-green-500" style={{ fontSize: '1.8rem' }}></i>&nbsp;<span className="font-semibold text-green-500">{I18n.get("conforme")}</span></>
        }

        else if ([0, false].includes(installation.isConforme)) {
            return <><i className="fa-light fa-thumbs-down text-red-500" style={{ fontSize: '1.8rem' }}></i>&nbsp;<span className="font-semibold text-red-500">{I18n.get("nonConforme")}</span></>
        }
    }

    return inst && (
        <div
            className={classNames({
                "h-full": false,
                "p-2 surface-0 shadow-1 border-round text-left w-full": true,
                "hover:surface-100": props.mode === "tournee" && !props.viewMode,
                "bg-green-100": props.mode === "tournee" && props.dragging
            })}
            style={{
                borderLeft: `3px solid ${data.installationColors[inst.genreInstallationId].color}`,
                backgroundColor: props.mode === "tournee" && props.dragging ? "red" : ""
            }}
        >
            <div className="flex flex-row justify-content-between sm:w-full md:w-full lg:w-11 xl:w-10">
                <div className="flex flex-row">
                    <div className="flex flex-column pt-1 pr-3  ">
                        <i className={data.installationColors[inst.genreInstallationId].icon} style={{ fontSize: '1.8rem', color: data.installationColors[inst.genreInstallationId].color }}></i>
                    </div>
                    <div className={classNames({
                        "flex flex-column w-full": !props.printMode,
                        "flex flex-column w-22rem": props.printMode
                    })}>
                        <div className="font-semibold text-600">{inst.nom}</div>
                        {inst.tel && <span><i className="fa-thin fa-phone"></i> : {inst.tel}</span>}
                        <div className="reference-externe pt-1">{I18n.get("reference")} : {inst.referenceExterne}</div>
                        <div className="">
                            {props.mode === "installation" && (inst.address.number || "") + " " + (inst.address.street || "") + ", " + (inst.address.codePostal || "") + " " + (inst.address.localite || "")}
                            {props.mode === "tournee" && (inst.adresse)}
                        </div>
                        {props.mode === "installation" && <div className="flex align-items-center">
                            {I18n.get(getLastReceptionStatus(inst))}
                        </div>}
                    </div>
                    {props.printMode && props.mode === "tournee" && <div className="flex flex-column ">
                        <div className="reference-externe text-xs">{I18n.get("owner")}&nbsp;:</div>
                        <div className="font-semibold text-600">{inst.owner}</div>
                        {inst.telOwner && <div className="flex align-items-center">
                            <i className="fa-thin fa-phone"></i> : {inst.telOwner}
                        </div>}
                    </div>}
                </div>
                <div className="flex flex-column justify-content-center">
                    {props.mode === "tournee" && !props.viewMode &&
                        <Button
                            icon="fa-light fa-trash-can"
                            rounded
                            outlined
                            severity="danger"
                            className="w-2rem h-2rem mt-2"
                            onClick={() => props.onRemove(inst)}
                        />}
                </div>
                {props.mode === "installation" && <div className="flex w-5 justify-content-end align-items-center" >
                    <div>{getConformiteImage(inst)}</div>
                </div>}
            </div>
        </div>
    )
}

export default InstallationCard;